import moment from 'moment';
import {
  Avatar, Card, Checkbox, Grid, IconButton, Typography,
} from '@mui/material';
import { Check } from '../../icons/check';
import { Eye } from '../../icons/eye';
import { ArrowRight } from '../../icons/arrow-right';
import style from './style';

type Props = {
  id: string,
  checked?: boolean,
  onCheckedTask: (id: string) => void,
  onClickGoTo: (key: string) => void,
  title: JSX.Element | string,
  date: Date,
}

export default function Task({
  checked, onCheckedTask, title, onClickGoTo, date, id,
}: Props): JSX.Element {
  const handleChange = () => onCheckedTask(id);
  const handleClick = () => onClickGoTo(id);

  return (
    <Card
      sx={ {
        backgroundColor: checked ? style.checkedColor.background : 'primary.contarst',
      } }
    >
      <Grid
        container
        spacing={ style.container.spacing }
        justifyContent={ style.container.justifyContent }
        alignItems={ style.container.alignItems }
        sx={ style.container.sx }
      >
        <Grid item >
          <Checkbox
            checked={ checked }
            disabled={ checked }
            onChange={ handleChange }
            inputProps={ style.inputProps }
            checkedIcon={ (
              <Check sx={ style.checkedColor.color } />
            ) }
          />
        </Grid>
        <Grid item >
          <Avatar sx={ style.avatar }>
            <Eye viewBox="-2 -2 24 24" />
          </Avatar>
        </Grid>
        <Grid item xs={ 9 } >
          <Typography
            sx={ {
              textDecoration: checked ? 'line-through' : 'none',
              color: checked ? 'text.secondary' : 'none',
            } }
          >
            { title }
          </Typography>
          <Typography
            variant="subtitle2"
            sx={ {
              color: 'text.secondary',
            } }
          >
            { moment(date).fromNow() }
          </Typography>
        </Grid>
        <Grid item>
          <IconButton
            onClick={ handleClick }
          >
            <ArrowRight
              sx={ style.checkedColor.color }
            />
          </IconButton>
        </Grid>
      </Grid>
    </Card>
  );
}

Task.defaultProps = {
  checked: false,
};
